import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import {
	iconBullhorn,
	iconChatBubble,
	iconLock,
	iconNewspaper,
	iconTimerOutline,
	iconTrendingUp,
} from '@change-corgi/design-system-legacy/icons';
import { Box, Container, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { LandingPageSlug } from 'src/app/pages/landing/template/shared/types';

type Props = {
	slug: LandingPageSlug;
};

const items = [
	{ icon: iconNewspaper, key: 'publish' },
	{ icon: iconTimerOutline, key: 'fast' },
	{ icon: iconTrendingUp, key: 'signatures' },
	{ icon: iconChatBubble, key: 'advice' },
	{ icon: iconBullhorn, key: 'reach' },
	{ icon: iconLock, key: 'secure' },
];

export function Footer({ slug }: Props): JSX.Element | null {
	return (
		<Box sx={{ backgroundColor: 'primary-greyBackground', width: '100%' }} px={[24, 40]} py={[40, 64]}>
			<Container px={8}>
				<Text sx={{ textAlign: 'center' }} size="huge">
					<Translate value={`landing.${slug}.footer.title`} />
				</Text>
				<Box sx={{ display: 'grid', gridTemplateColumns: ['1fr', '1fr 1fr 1fr'], gap: '16px 32px' }} mt={32}>
					{items.map((el) => {
						return (
							<Flex key={el.key}>
								<Icon icon={el.icon} size="xxl" color="primary-changeRed" mr={16} />
								<Box sx={{ flex: 1 }}>
									<Text mb={8} fontWeight={['normal', 'bold']}>
										<Translate value={`landing.${slug}.footer.${el.key}.title`} />
									</Text>
									<Box sx={{ display: ['none', 'block'] }}>
										<Text as="p">
											<Translate value={`landing.${slug}.footer.${el.key}.body`} />
										</Text>
									</Box>
								</Box>
							</Flex>
						);
					})}
				</Box>
			</Container>
		</Box>
	);
}
